import React, { useMemo, useState } from 'react';
import { EditableOutlined } from '@duxton-web/icons';
import {
  Button,
  Form,
  Input,
  Modal,
  ModalProps,
  Tooltip,
} from '@duxton-web/ui';
import { debounce } from 'lodash';

import { useExperimentDispatchContext } from '../../contexts/experiment-context';
import { editTreatment } from '../../store/actions/experiment/action-creators';

const EditTreatmentModal = ({
  index,
  name,
  open,
  onCancel,
  onOk,
}: ModalProps & { index: number; name: string }) => {
  if (!open) return null;

  const experimentDispatch = useExperimentDispatchContext();

  const [form] = Form.useForm();
  const initialValues = {
    name: name,
  };

  const [isValid, setIsValid] = useState(false);

  const handleOnFieldsChange = useMemo(
    () =>
      debounce(() => {
        form
          .validateFields()
          .then(() => {
            setIsValid(true);
          })
          .catch(() => {
            setIsValid(false);
          });
      }, 700),
    [form],
  );

  return (
    <Modal
      centered
      width={600}
      title="Edit Treatment"
      open={open}
      onCancel={onCancel}
      onOk={(e) => {
        experimentDispatch(editTreatment(index, form.getFieldValue('name')));

        onOk(e);
      }}
      okText="Save"
      maskClosable={false}
      okButtonProps={{ size: 'small', disabled: !isValid }}
      cancelButtonProps={{ size: 'small' }}
    >
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={handleOnFieldsChange}
        initialValues={initialValues}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: 'Please enter a name' },
            { max: 20, message: 'Name cannot be longer than 20 characters' },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EditTreatment = ({ index, name }: { index: number; name: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Click here to edit treatment">
        <Button
          shape="circle"
          size="small"
          type="text"
          icon={<EditableOutlined />}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <EditTreatmentModal
        index={index}
        name={name}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      />
    </>
  );
};

export default EditTreatment;
